import { render } from "./WordBannerView.vue?vue&type=template&id=1a2426bc&scoped=true"
import script from "./WordBannerView.vue?vue&type=script&lang=js"
export * from "./WordBannerView.vue?vue&type=script&lang=js"

import "./WordBannerView.vue?vue&type=style&index=0&id=1a2426bc&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2426bc"]])

export default __exports__